import React, { useState, lazy, useEffect } from 'react';
import { Grid, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import LoginedBase from '../login-base'
import { Outlet, Link, useLoaderData } from "react-router-dom";
import { useParams } from 'react-router-dom';


const LShell = () => {
    const { module } = useParams()
    const navi = useNavigate();

    return (
        <Outlet />
    )
}

export default LShell;